import LTable from './LTable.vue'

export default (Vue) => {
  Vue.component(LTable.name, LTable)
}
